export const SIZE_SMALL_HEIGHT = '3.2rem';
export const SIZE_MEDIUM_HEIGHT = '4rem';
export const SIZE_LARGE_HEIGHT = '5.6rem';
